/* eslint-disable */
// helpers for program
import get from '@neonaut/lib-js/es/object/getPath';
import merge from '@neonaut/lib-js/es/object/deep-extend';
import replace from '@neonaut/lib-js/es/string/replaceRegex';

import createCachedStyleFunction from '@mapsight/lib-ol/style/createCachedStyleFunction';

import __vectorStyle_fill from 'ol/style/fill';
import __vectorStyle_stroke from 'ol/style/stroke';
import __vectorStyle_image from 'ol/style/image';
import __vectorStyle_icon from 'ol/style/icon';
import __vectorStyle_circle from 'ol/style/circle';
import __vectorStyle_style from 'ol/style/style';

const createHash = a => JSON.stringify(a);

export default createCachedStyleFunction({
	constructorsMap: {fill: __vectorStyle_fill,
		stroke: __vectorStyle_stroke,
		image: __vectorStyle_image,
		icon: __vectorStyle_icon,
		circle: __vectorStyle_circle,
		style: __vectorStyle_style},
	allowedStyles: ['features','userGeolocation'],
	allowedProps: ['mapsightIconId','number','state','accuracy'],
	declarationHashFunction: (env, props, hashPrefix, geometryType, style) => {
		let hash = hashPrefix + '|' + geometryType + '|';
		const addHash = a => { hash += ',' + a; };

		switch (style) {
			case 'features':
				addHash(1);
				if (props.mapsightIconId) {
					addHash(2);
					addHash('@' + createHash(props.mapsightIconId));
				}
				if (props.mapsightIconId == 'museum' && props.mapsightIconId == 'theater' || props.mapsightIconId == 'spielplatz' || props.mapsightIconId == 'sportanlage') {
					addHash(3);
				}
				if (props.number) {
					addHash(4);
					addHash('@' + createHash(props.number));
				}
				if (props.state == 'select' || props.state == 'preselect') {
					addHash(5);
				}
				if (props.state == 'select' && props.mapsightIconId || props.state == 'preselect' && props.mapsightIconId) {
					addHash(6);
					addHash('@' + createHash(props.mapsightIconId));
				}
				if (props.state == 'select' && props.number || props.state == 'preselect' && props.number) {
					addHash(7);
					addHash('@' + createHash(props.number));
				}
				if (geometryType == 'Polygon' || geometryType == 'MultiLineString') {
					addHash(8);
				}
				if (geometryType == 'MultiPolygon') {
					addHash(9);
				}
				if (props.state == 'highlight' || props.state == 'select') {
					addHash(10);
				}
				if (props.state == 'highlight') {
					addHash(11);
				}
				if (props.state == 'highlight' && geometryType == 'Polygon' || props.state == 'highlight' && geometryType == 'MultiLineString' || props.state == 'highlight' && geometryType == 'MultiPolygon') {
					addHash(12);
				}
				if (props.state == 'preselect' || props.state == 'select') {
					addHash(13);
				}
				if (props.state == 'preselect' && geometryType == 'Polygon' || props.state == 'preselect' && geometryType == 'MultiLineString' || props.state == 'preselect' && geometryType == 'MultiPolygon' || props.state == 'select' && geometryType == 'Polygon' || props.state == 'select' && geometryType == 'MultiLineString' || props.state == 'select' && geometryType == 'MultiPolygon') {
					addHash(14);
				}
				break;
			case 'userGeolocation':
				addHash(15);
				addHash('@' + createHash(props.accuracy));
				break;
		}

		return hash;
	},
	declarationFunction: (env, props, geometryType, style) => {
		const declaration = {};
		const declare = a => merge(declaration, a);

		switch (style) {
			case 'features':
				declare({ default: { zIndex: { value: 102 },
					fill: { color: { value: '#002856' } },
					stroke: { color: { value: '#002856' },
						width: { value: 4 } },
					image: { type: { value: 'icon' } },
					icon: { snapToPixel: { value: 'true' },
						scale: { value: 1 },
						offsetX: { value: 0 },
						offsetY: { value: 0 },
						sizeX: { value: 40 },
						sizeY: { value: 40 },
						src: { value: '/neonaut-pwa/img/map-icons/ort-default.svg' } } } });
				if (props.mapsightIconId) {
					declare({ default: { icon: { src: { value: '/neonaut-pwa/img/map-icons/' + props.mapsightIconId + '-default.svg' } } } });
				}
				if (props.mapsightIconId == 'museum' && props.mapsightIconId == 'theater' || props.mapsightIconId == 'spielplatz' || props.mapsightIconId == 'sportanlage') {
					declare({ default: { icon: { sizeX: { value: 42 } } } });
				}
				if (props.number) {
					declare({ default: { icon: { src: { value: '/neonaut-pwa/img/map-icons/' + props.number + '-default.svg' },
						scale: { value: 1 },
						sizeX: { value: 94 },
						sizeY: { value: 55 } } } });
				}
				if (props.state == 'select' || props.state == 'preselect') {
					declare({ default: { icon: { src: { value: '/neonaut-pwa/img/map-icons/ort-active.svg' } } } });
				}
				if (props.state == 'select' && props.mapsightIconId || props.state == 'preselect' && props.mapsightIconId) {
					declare({ default: { icon: { src: { value: '/neonaut-pwa/img/map-icons/' + props.mapsightIconId + '-active.svg' } } } });
				}
				if (props.state == 'select' && props.number || props.state == 'preselect' && props.number) {
					declare({ default: { icon: { src: { value: '/neonaut-pwa/img/map-icons/' + props.number + '-active.svg' } } } });
				}
				if (geometryType == 'Polygon' || geometryType == 'MultiLineString') {
					declare({ default: { zIndex: { value: 101 } } });
				}
				if (geometryType == 'MultiPolygon') {
					declare({ default: { zIndex: { value: 100 } } });
				}
				if (props.state == 'highlight' || props.state == 'select') {
					declare({ default: { stroke: { color: { value: '#57ffff' } },
						cursor: { value: 'pointer' } } });
				}
				if (props.state == 'highlight') {
					declare({ default: { zIndex: { value: 110 } } });
				}
				if (props.state == 'highlight' && geometryType == 'Polygon' || props.state == 'highlight' && geometryType == 'MultiLineString' || props.state == 'highlight' && geometryType == 'MultiPolygon') {
					declare({ default: { zIndex: { value: 100 } } });
				}
				if (props.state == 'preselect' || props.state == 'select') {
					declare({ default: { zIndex: { value: 301 } } });
				}
				if (props.state == 'preselect' && geometryType == 'Polygon' || props.state == 'preselect' && geometryType == 'MultiLineString' || props.state == 'preselect' && geometryType == 'MultiPolygon' || props.state == 'select' && geometryType == 'Polygon' || props.state == 'select' && geometryType == 'MultiLineString' || props.state == 'select' && geometryType == 'MultiPolygon') {
					declare({ default: { zIndex: { value: 100 } } });
				}
				break;
			case 'userGeolocation':
				declare({ default: { zIndex: { value: 100 } },
					accuracy: { image: { type: { value: 'circle' } },
						circle: { radius: { value: '' + eval('' + props.accuracy + ' / ' + env.resolution + '') + '' },
							fill: { color: { value: 'rgba(51, 153, 204, 0.61)' } } } },
					point: { image: { type: { value: 'circle' } },
						circle: { radius: { value: 6 },
							fill: { color: { value: '#3399cc' } } } } });
				break;
		}

		return declaration;
	},
});
